import EcommerceChangeFiltersView from "app/pages/sales-intelligence/sub-modules/signals/components/views/EcommerceSignalFiltersView/EcommerceChangeFiltersView/EcommerceChangeFiltersView";
import EcommerceReachedFiltersView from "app/pages/sales-intelligence/sub-modules/signals/components/views/EcommerceSignalFiltersView/EcommerceReachedFiltersView/EcommerceReachedFiltersView";
import EcommerceSignalSubType from "app/pages/sales-intelligence/sub-modules/signals/models/ecommerce/EcommerceSignalSubType";
import type { EcommerceSignalsDescription } from "app/pages/sales-intelligence/sub-modules/signals/models/miscellaneous/SignalsDescription";
import type EcommerceSignalFiltersViewResolver from "app/pages/sales-intelligence/sub-modules/signals/models/view/ecommerce/EcommerceSignalFiltersViewResolver";
import type EcommerceSignalFiltersViewProps from "app/pages/sales-intelligence/sub-modules/signals/models/view/ecommerce/EcommerceSignalFiltersViewProps";
import {
    mapEcommerceDirectionOptions,
    mapEcommercePeriodOptions,
} from "app/pages/sales-intelligence/sub-modules/signals/utils/ecommerce/mapEcommerceDescriptionOptions";
import type { ComponentType } from "react";

type FactoryDeps = {
    ecommerce: EcommerceSignalsDescription | undefined;
};

export default function createEcommerceSignalFiltersViewResolver(
    deps: FactoryDeps,
): Readonly<EcommerceSignalFiltersViewResolver> {
    const directionOptions = mapEcommerceDirectionOptions(deps.ecommerce?.directions);
    const periodOptions = mapEcommercePeriodOptions(deps.ecommerce?.periods);

    const EcommerceChangeFiltersViewWithOptions: ComponentType<EcommerceSignalFiltersViewProps> = (props) => (
        <EcommerceChangeFiltersView
            {...props}
            directionOptions={directionOptions}
            periodOptions={periodOptions}
        />
    );

    function getFiltersView(subType: EcommerceSignalSubType) {
        switch (subType) {
            case EcommerceSignalSubType.OnlineRevenueChange:
            case EcommerceSignalSubType.OnlineTransactionsChange:
                return EcommerceChangeFiltersViewWithOptions;
            case EcommerceSignalSubType.OnlineRevenueReached: {
                const bucketOptions = deps.ecommerce?.onlineRevenueBuckets ?? [];

                return function OnlineRevenueReachedWrapper(props: EcommerceSignalFiltersViewProps) {
                    return (
                        <EcommerceReachedFiltersView
                            {...props}
                            bucketOptions={bucketOptions}
                        />
                    );
                };
            }
            case EcommerceSignalSubType.OnlineTransactionsReached: {
                const bucketOptions = deps.ecommerce?.monthlyTransactionsBuckets ?? [];

                return function OnlineTransactionsReachedWrapper(props: EcommerceSignalFiltersViewProps) {
                    return (
                        <EcommerceReachedFiltersView
                            {...props}
                            bucketOptions={bucketOptions}
                        />
                    );
                };
            }
            default:
                return undefined;
        }
    }

    return { getFiltersView };
}
